import React from "react";
import { Button } from "./Button";
import classNames from "classnames";
import { Tooltip } from "antd";
import { SectionWrapper } from "./SectionWrapper";
import LinkExternalIcon from "../icons/link_external.svg";

export type SectionField = {
  label: string;
  value?: string;
  isSecret?: boolean;
  hasEditButton?: boolean;
  hasDeleteButton?: boolean;
  fullValue?: boolean;
  isImage?: boolean;
  customAction?: React.ReactNode;
  editBtnText?: string;
  customEditBtn?: {
    label: string;
    onClick?: () => void;
  };
  onEditBtnClick?: () => void;
  tooltipText?: string;
};

export type SectionProps = {
  title: string;
  additionalFieldsSpace?: boolean;
  displayUpdateBtn?: boolean;
  updateActionLink?: string;
  onUpdateClick?: () => void;
  fields: SectionField[];
};

export const Section = ({
  title,
  displayUpdateBtn,
  updateActionLink,
  additionalFieldsSpace,
  fields,
  onUpdateClick,
}: SectionProps) => {
  return (
    <SectionWrapper
      title={title}
      sectionAction={
        displayUpdateBtn && (
          <Button
            className="flex items-center gap-2"
            href={updateActionLink}
            onClick={onUpdateClick}
          >
            Update <LinkExternalIcon />
          </Button>
        )
      }
    >
      <div
        className={classNames("flex flex-col", {
          "gap-4": !additionalFieldsSpace,
          "gap-8": additionalFieldsSpace,
        })}
      >
        {fields.map((field, index) => (
          <div
            key={index}
            className={classNames(
              "flex flex-col items-start lg:flex-row lg:items-center justify-between gap-3 py-2"
            )}
          >
            <div>
              <div className="text-xs uppercase">{field.label}</div>
              {field.isImage ? (
                <img
                  src={field.value}
                  className="h-[80px] w-[80px] rounded-full"
                />
              ) : (
                <div
                  className={
                    field.fullValue
                      ? ""
                      : "max-w-[300px] truncate overflow-hidden"
                  }
                >
                  {field.isSecret ? "********" : field.value}
                </div>
              )}
            </div>
            <div className="flex gap-2">
              {field.customAction ? (
                field.customAction
              ) : (
                <>
                  {field.hasDeleteButton && <Button>Delete</Button>}
                  {field.hasEditButton && (
                    <Tooltip
                      title={
                        !field.onEditBtnClick && !field.customEditBtn?.onClick
                          ? field.tooltipText
                          : ""
                      }
                    >
                      <span>
                        <Button
                          style={
                            !!field.customEditBtn
                              ? {
                                  backgroundColor: "#E02020",
                                }
                              : undefined
                          }
                          className={classNames({
                            "text-white": !!field.customEditBtn,
                          })}
                          onClick={
                            field.onEditBtnClick ?? field.customEditBtn?.onClick
                          }
                          disabled={
                            !field.onEditBtnClick &&
                            !field.customEditBtn?.onClick
                          }
                        >
                          {field.customEditBtn?.label ??
                            field.editBtnText ??
                            "Edit"}
                        </Button>
                      </span>
                    </Tooltip>
                  )}
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </SectionWrapper>
  );
};
